import { colourSelectors } from "../Selectors/index";

const initValue = {
  loading: false,
  rows: [],
};

export const colourReducer = (state = initValue, { type, payload }) => {
  switch (type) {
    case colourSelectors.GET_COLOUR:
      return {
        ...state,
        loading: true,
      };
    case colourSelectors.GET_COLOUR_SUCCESS:
      return {
        loading: false,
        rows: payload,
      };

    default:
      return state;
  }
};
